import { setRoutineState } from '@/actions/routine';
import { useSignalROn } from '@/hooks/useSignalROn';
import { useDispatch } from 'react-redux';
export const RoutineStateProvider = () => {
  const dispatch = useDispatch();
  useSignalROn('RoutineDataUpdated', state => dispatch(setRoutineState(state)));
  return null;
};
